import React from 'react';
import { Button, Space } from 'antd';
import Modal from '../../main/components/Modal';

const ModalConfirmation = ({
  visible,
  confirmationTitle,
  bodyText,
  onClose,
  onConfirm,
  confirmationText,
  locales,
}) => {
  return (
    <Modal isOpen={visible} onClose={onClose} title={confirmationTitle}>
      <Space>
        <div className="flex flex-col gap-6">
          <p className="confirmation-modal__body-title text-center">
            {bodyText}
          </p>
          <div className="flex flex-row gap-2 justify-end">
            <Button onClick={onClose} size="small">
              {locales.admin.cancel}
            </Button>
            <Button type="primary" danger onClick={onConfirm} size="small">
              {confirmationText || locales.admin.confirm}
            </Button>
          </div>
        </div>
      </Space>
    </Modal>
  );
};

export default ModalConfirmation;
